<template>
  <v-app>
    {{/* eslint-disable */}}
    <!-- <h1>App View</h1> -->
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App'
};
</script>
<style>
.main_color {
  color: #7f67fb !important;
}
.main_bg_color {
  background-color: #7f67fb !important;
}
.edit_btn {
  cursor: pointer !important;
  color: #51e1ed !important;
}
.edit_btn:hover {
  color: #6143f7 !important;
}
.del_btn {
  cursor: pointer !important;
  color: #757575 !important;
}
.del_btn:hover {
  color: #bf360c !important;
}
.alertCenter {
  position: fixed;
  bottom: 2%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
}
.ql-snow .ql-tooltip {
  left: 0px !important;
}
</style>
